import { FC, useContext } from "react";
import {
  Avatar,
  Box,
  Card,
  CardActionArea,
  CardContent,
  Chip,
  Grid,
  Typography,
} from "@material-ui/core";
import { useHistory } from "react-router";

import PoolCardStyle from "./PoolsStyle";
import PoolIcon from "../../assets/images/GAINSFish.svg";
import PoolContext from "../../store/Pool/PoolContext";

import { USDollar } from "../../utils/currency/usd";
import { Colors } from "../../helpers/theme";
import { getNetworkBadge } from "../../utils/web3/getNetworkBadge";

const PoolCardClosedMobile: FC<any> = ({
  id,
  slug,
  imgSrc,
  title,
  totalRaise,
  networks,
  ath,
  ticker,
  distributionScAddress,
  poolTokenPrice,
}) => {

  const classes = PoolCardStyle();
  const history = useHistory();

  const { setActivePool } = useContext<any>(PoolContext);

  const handleClick = () => {
    setActivePool({ id, networks, name: title, slug });
    let urlId;
    if(slug){
      urlId = slug
    }else {
      urlId = id
    }
    history.push(`/project/${urlId}`);
  };

  return (
    <Grid item lg={4} md={4} sm={6} xs={12}>
      <Card className={classes.rootClosed} variant="outlined" onClick={handleClick}>
        <CardActionArea>
          <Grid
            container
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            className={classes.iconWrapperClosed}
          >
            <Grid
              item
            >
              <Grid
                container
                alignItems="center"
              >
                <Grid item>
                  <Avatar alt="Project Logo Avatar" src={imgSrc ? imgSrc : PoolIcon} className={classes.avatarClosed} />
                </Grid>
                <Grid 
                item
                style={{
                  marginLeft: "15px",
                }}
                >
                  <Typography
                    variant="h5"
                    component="h2"
                    className={classes.title2}
                  >
                    {title}
                  </Typography>
                  <Typography
                    variant="h5"
                    component="h5"
                    style={{
                      color: Colors.blackLight,
                      fontWeight: 200,
                      fontSize: "14px",
                    }}
                  >
                    {`$${ticker?.toUpperCase()}`}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              {
                distributionScAddress && distributionScAddress.length > 0 && (
                  <>
                    {
                      getNetworkBadge(distributionScAddress[0].chain) 
                      ? (
                        <Avatar
                          alt="Network"
                          src={getNetworkBadge(distributionScAddress[0].chain)}
                          className={classes.network}
                        />
                      ) : (
                        <>
                          <Chip className="fw-bold" color="primary" label={distributionScAddress[0].chain} />
                        </>
                      )
                    }
                  </>
                )
              }
            </Grid>
          </Grid>
          <CardContent className={classes.contentClosed}>
            <Grid
              container
              direction="column"
              className={classes.detailContainerClosed}
            >
              <Grid item>
                <Grid
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Grid item>
                    <Typography>Total Raise</Typography>
                  </Grid>
                  <Grid item xs={true}>
                    <Box border={"1px #ECF0F3 dashed"} marginX={"18px"}></Box>
                  </Grid>
                  <Grid item>
                    <Typography>
                      <span className="detailValue darkSlate">{`${USDollar.format(totalRaise)}`}</span>
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item>
                <Grid
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Grid item>
                    <Typography>ATH ROI</Typography>
                  </Grid>
                  <Grid item xs={true}>
                    <Box border={"1px #ECF0F3 dashed"} marginX={"18px"}></Box>
                  </Grid>
                  <Grid item>
                    <Typography>
                      <span className="detailValue">{(ath) ? parseFloat(((ath) / poolTokenPrice).toFixed(1)) + "x" : "NA"}</span>
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </CardActionArea>
      </Card>
    </Grid>
  );
};

export default PoolCardClosedMobile;
